/* @flow */
import { horizontalSmallDeviceBreakpoint } from 'src/shared/app/base/style/util/responsive';

export default {
  root: {
    [horizontalSmallDeviceBreakpoint]: {
      position: 'static !important',
      minWidth: 'auto !important',
      width: 'auto !important',
    },
  },
  wrapper: {
    [horizontalSmallDeviceBreakpoint]: {
      position: 'static !important',
      minWidth: 'auto !important',
      width: 'auto !important',
    },
  },
};
